import type { useCustomerStore } from '@stores/me/customer'
import type { ComputedRef } from 'vue'

interface BtnSupportPayload {
  customerStore: ReturnType<typeof useCustomerStore>
}
interface BtnSupportReturn {
  disabled: ComputedRef<boolean>
}
export const useBtnSupport = (payload: BtnSupportPayload): BtnSupportReturn => {
  const disabled = computed(() => !payload.customerStore.hasData)

  return  {
    disabled,
  }
}
